import { StyleSheet, View, Image, TextInput, Text, FlatList, SafeAreaView, ActivityIndicator, ScrollView, TouchableOpacity } from 'react-native';
import { useState, useEffect, useCallback } from 'react';
import * as ImagePicker from 'expo-image-picker';
import { doc, collection, getDocs, setDoc, addDoc, Timestamp, query, where, orderBy } from "firebase/firestore"; 
import { ref, uploadBytes, uploadString, getDownloadURL } from "firebase/storage";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import { MenuProvider, Menu, MenuOptions, MenuOption, MenuTrigger } from 'react-native-popup-menu';
import { FAB, Chip } from "@react-native-material/core";
import Icon from "@expo/vector-icons/MaterialCommunityIcons";
// import { StatusBar } from 'expo-status-bar';
import Swiper from 'react-native-web-swiper';

import { db } from '../firebaseConfig';
import { storage } from '../firebaseConfig';
import moment from "moment";
import { getDistanceFromLatLonInMiles }  from '../services/utils/General'

import ImageViewer from '../components/ImageViewer';
const PlaceholderImage = require('../assets/images/background-image.png');
import Button from '../components/shared/Button';
import ProfileModal from '../components/ProfileModal';
import SignInRequiredModal from './SignInRequiredModal';

const DEFAULT_ASPECT_RATIO = 3 / 2;
// falls back to the default ratio for older posts saved before dimensions were captured
function getAspectRatio(width, height) {
  return width && height ? width / height : DEFAULT_ASPECT_RATIO;
}

export default function DetailsScreen({ route, navigation }) {
 

  const [username, setUsername] = useState(null);
  const [comment, setComment] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [post, setPost] = useState(null);
  const [hasMultipleImages, setHasMultipleImages] = useState(false);
  const [comments, setComments] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [userImageUrl, setUserImageUrl] = useState(null);
  const [bar, setBar] = useState(null);
  const [data, setData] = useState(null);
  const [location, setLocation] = useState(null);
  const [isProfileModalVisible, setIsProfileModalVisible] = useState(false);
  const [profileUserInfo, setProfileUserInfo] = useState(null);
  const [isSignInRequiredModalVisible, setIsSignInRequiredModalVisible] = useState(false);
  //const [created, setCreated] = useState(null);

  var { userId } = '';
  var { postId } = '';
  //var { created } = null;

  //console.log("image url:", data.storageImageUrl);

  async function fetchData() {

    // const q = query(collection(db, "Posts"), orderBy('created', 'desc'));

    // const querySnapshot = await getDocs(q);
    // setPosts(querySnapshot.docs.map(doc => ({
    //   id: doc.id,
    //   data: doc.data()
    // })));

    // setLoading(false);
    // console.log("route.params.data.id:", route.params.data.id);
    var path = 'Posts/' + route.params.data.id + '/Comments';
    // console.log("path:", path);

    const q = 
      query(
        collection(db, 'Posts/' + route.params.data.id + '/Comments'),
        orderBy('created', 'asc')
      );

    const querySnapshot = await getDocs(q);

    setComments(querySnapshot.docs.map(doc => ({
      id: doc.id,
      data: doc.data()
    })));

  };

  useEffect(() => {

    (async () => {
      setLoading(true);
      
      let savedUserId = window.localStorage.getItem('userId');
      if (savedUserId) {
        userId = savedUserId;
      }

      postId = route.params.data.id;

      

      //await fetchData();

      
      var data = route.params.data.data;
      //TODO: switch all to using this?
      setData(data);

      setUsername(data.username);
      setComment(data.comment);
      setImageUrl(data.storageImageUrl);
      setPost(route.params.data);
      setUserImageUrl(data.userInfo.storageImageUrl);
      setBar(data.bar);
      //setCreated(data.created);
      
      if (route.params.location) {
        setLocation(route.params.location);
      }

      
      // console.log('data.created', data.created);

      if (data.storageImageUrl && data.storageImageUrl2)
      {
        setHasMultipleImages(true);
      }

      //setLoading(false);

      // listen for a navigation back.  this also runs on first load.
      const focusHandler = navigation.addListener('focus', () => {
        (async () => {

          await fetchData();
          setLoading(false);

        })();
      });

    })();
  }, [])

  async function handleAddComment(postId) {
    let savedUserId = window.localStorage.getItem('userId');
    if (!savedUserId) {
      setIsSignInRequiredModalVisible(true);
      return;
    }
    else {
      navigation.navigate('CommentScreen', { data: postId, postId: postId});
    }
  }

  const closeSignInRequiredModal = async () => {
    setIsSignInRequiredModalVisible(false);
  }

  const openProfileModal = async (profileUserId, profileUsername, profileImage) => {
    setProfileUserInfo({ userId: profileUserId, username: profileUsername, storageImageUrl: profileImage });
    setIsProfileModalVisible(true);
  }

  const closeProfileModal = async () => {
    setIsProfileModalVisible(false);
  }

  const renderComment = useCallback(({ item }) => (
    <View style={styles.commentContainer}>
      <View style={styles.commentHeader}>
        <Text style={styles.commentUsername}>{item.data.username}</Text>
        <View>
          <Menu>
            <MenuTrigger>
              <FontAwesome
                name="ellipsis-v"
                size={18}
                color="#666"
                style={styles.commentMenuIcon}
              />
            </MenuTrigger>
            {userId == item.data.userId &&
              <MenuOptions>
                <MenuOption onSelect={() => navigation.navigate('CommentScreen', { data: item, postId: postId })} text='Edit' />
              </MenuOptions>
            }
            {userId != item.data.userId &&
              <MenuOptions>
                <MenuOption onSelect={() => console.log(`Not called`)} text='Report this comment' />
              </MenuOptions>
            }
          </Menu>
        </View>
      </View>
      
      <Text style={styles.commentText}>{item.data.comment}</Text>
    </View>
), []);

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <ScrollView style={{ flex: 1, padding: 5, backgroundColor: '#F2F2F2' }}>
      {isLoading ? <></> :
        (<><View style={{ flexDirection: 'row', marginBottom: 15 }}>
          {userImageUrl &&
            <TouchableOpacity onPress={() => openProfileModal(data.userId, username, userImageUrl)}>
              <Image source={{ uri: userImageUrl }} style={styles.userImage} />
            </TouchableOpacity>}
          <View style={{ flex: 1, flexDirection: 'column', marginLeft: 5, justifyContent: 'center' }}>
            {username && <Text style={{ fontSize: 18, textAlign: 'left' }}>{username}</Text>}
            <Text style={{ fontSize: 18, textAlign: 'left' }}>{bar}</Text>
            <Text style={{ color: '#ccc', marginRight: 10, flex: 1, flexDirection: 'row', textAlign: 'left', }}>
              {moment(data.created.toDate()).format("h A")} {moment(data.created.toDate()).format('dddd')} {moment(data.created.toDate()).fromNow()}
            </Text>
            {/* <Text style={{ color: '#ccc', marginRight: 5 }}>
              {getDistanceFromLatLonInMiles(location?.coords.latitude, location?.coords.longitude, data.latitude, data.longitude).toFixed(2)} miles
            </Text> */}
          </View>
        </View>
        
        {hasMultipleImages && data.storageImageUrl3 && data.storageImageUrl3.length > 0 &&
          <View style={[styles.imageRow, { aspectRatio: getAspectRatio(data.imageWidth, data.imageHeight) }]}>
            <Swiper
              controlsProps={{
                dotsPos: 'bottom',
                prevPos: false, /* hide prev button */
                nextPos: false, /* hide next button */
                // cellsStyle: {
                //   'bottom': { position: 'absolute', bottom: -20, zIndex: 1000 },
                //   'topLeft': { position: 'absolute', top: 0, left: 0 },
                // },
              }}
            >
              <View style={styles.swiperSlide}>
                <ImageViewer selectedImage={data.storageImageUrl} enablePanZoom={false} />
              </View>
              <View style={styles.swiperSlide}>
                <ImageViewer selectedImage={data.storageImageUrl2} enablePanZoom={false} />
              </View>
              <View style={styles.swiperSlide}>
                <ImageViewer selectedImage={data.storageImageUrl3} enablePanZoom={false} />
              </View>
            </Swiper>
          </View>
        }
         {hasMultipleImages && !data.storageImageUrl3 &&
          <View style={[styles.imageRow, { aspectRatio: getAspectRatio(data.imageWidth, data.imageHeight) }]}>
            <Swiper
              controlsProps={{
                dotsPos: 'bottom',
                prevPos: true, /* hide prev button */
                nextPos: true, /* hide next button */
                // cellsStyle: {
                //   'bottom': { position: 'absolute', bottom: -20, zIndex: 1000 },
                //   'topLeft': { position: 'absolute', top: 0, left: 0 },
                // },
              }}
            >
              <View style={styles.swiperSlide}>
                {/* pinch to zoom makes the Swiper not work. touch gestures conflict. */}
                <ImageViewer selectedImage={data.storageImageUrl} enablePanZoom={false} />
              </View>
              <View style={styles.swiperSlide}>
                <ImageViewer selectedImage={data.storageImageUrl2} enablePanZoom={false} />
              </View>
            </Swiper>
          </View>
        }
        {!hasMultipleImages &&
          <View style={[styles.imageContainer, { aspectRatio: getAspectRatio(data.imageWidth, data.imageHeight) }]} data-testid="single-image-container">
            <ImageViewer selectedImage={imageUrl} aspectRatio={getAspectRatio(data.imageWidth, data.imageHeight)} />
          </View>
        }
        
        <View style={{ flexDirection: 'row' }}>
        <Text style={{ fontSize: 18, textAlign: 'left' }}>{comment}</Text>
        </View></>)}

        {isLoading ? <ActivityIndicator size="large" color="#ffd33d" animating={isLoading} hidesWhenStopped={true} /> :
          (
            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'space-between', marginTop: 5 }}>
              <FlatList
                data={comments}
                keyExtractor={({ id }, index) => id}
                renderItem={renderComment}
                style={{ flex: 1 }}
              />
            </View>
          )}

        
      </ScrollView>
      {/* <View style={{ alignItems: 'center', justifyContent: 'center', padding: 10 }}>
        <Button theme="basic" label="Add a comment" onPress={() => navigation.navigate('CommentScreen', { data: post.id, postId: post.id })} />
      </View>   */}
      {/* <StatusBar style="auto" /> */}
      {isLoading ? <></> :
          (<FAB
            variant="standard"
            icon={props => <Icon name="plus" {...props} />}
            //label=""
            color="#674FE0"
            style={styles.fab}
            onPress={() => handleAddComment(post.id)}
          />)}
      <ProfileModal
        message={""}
        visible={isProfileModalVisible}
        dismiss={closeProfileModal}
        userInfo={profileUserInfo}
      ></ProfileModal>
      <SignInRequiredModal
        visible={isSignInRequiredModalVisible}
        dismiss={closeSignInRequiredModal}
        onCreateAccount={() => {
          setIsSignInRequiredModalVisible(false);
          navigation.navigate('CreateAccountScreen', { location: location });
        }}
      ></SignInRequiredModal>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F2F2F2',
    //alignItems: 'top',
    padding: 20
  },
  main: {
    flex: 1,
    //flexDirection: 'column',
    backgroundColor: '#yellow',
    //alignItems: 'top',
  },
  imageRow: {
    //paddingTop: 5,
    //alignContent: 'center',
    //flex: 1,
    //flexDirection: 'row',
    width: '100%',
    height: undefined,
  },
  swiperSlide: {
    width: '100%',
    height: '100%',
    paddingBottom: 10,
    marginRight: 5,
  },
  imageContainer: {
    //paddingTop: 5,
    //alignContent: 'center',
    //flex: 1,
    //flexDirection: 'row',
    width: '100%',
    height: undefined,
    paddingBottom: 10,
    marginRight: 5,
  },
  // footerContainer: {
  //   flex: 1 / 8,
  //   alignItems: 'center',
  // },
  image: {
    // flex: 1,
    // flexDirection: 'row',
    width: '100%',
    height: undefined,
    aspectRatio: 3 / 2,
  },
  fab: {
    position: 'absolute',
    bottom: 16,
    right: 16,
  },
  userImage: {
    width: 40,
    height: 40,
    borderRadius: 40/2,
    marginRight: 5,
  },
  commentContainer: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 12,
    marginBottom: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 2,
  },
  commentHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  commentUsername: {
    flex: 1,
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  commentMenuIcon: {
    padding: 4,
  },
  commentText: {
    fontSize: 15,
    lineHeight: 20,
    color: '#444',
  },
});

